import {Button, Flex} from '@priority-software/priority-style-react';
import React, {FC} from 'react';
import {TVoidFunction} from '../../../../../../types';
import styles from '../../../../../styles.module.scss';
import {createDataTestId} from '../../../../../../../../utils/dataTestId';

interface ITags {
    tags: string[];
    onClick: TVoidFunction<string>;
}

interface ITag {
    name: string;
    index: number;
    onClick: TVoidFunction<string>;
}

export const Tags: FC<ITags> = ({tags, onClick}) => {
    return (
        <Flex direction="row" justifyContent="flex-start">
            {tags.map((tag, index) => {
                return <Tag key={index} index={index} name={tag} onClick={onClick} />;
            })}
        </Flex>
    );
};

export const Tag: FC<ITag> = ({name, onClick, index}) => {
    return (
        <Button
            {...createDataTestId(`email-dynamic-values-tag-${index}`, true)}
            componentClasses={styles.tagContainer}
            onClick={() => onClick(name)}
            width="contentWidth"
            size={'small'}
            skin="secondary"
        >
            {name}
        </Button>
    );
};
